import {
  Plug,
  Image,
  Title,
  Description
} from './styles'

interface Props {
  image: React.ReactElement | string;
  title: string;
  description: string;
}

export default function PlugComponent({ image, title, description }: Props) {
  return (
    <Plug>
      <Image>{image}</Image>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Plug>
  )
}